<div class="business-panel">
  <div class="btns-filters">
    <div class="buscador-business container-form d-flex align-items-center borderInput">
      <i class="fal fa-search search-icon pointer-in" (click)="searchBusiness(searchInput.value)"></i>
      <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar empresa" [ngModel]="searchText"
        (input)="searchBusiness(searchInput.value)">
    </div>
    <div class="btns-create">
      <div class="btn-create m-0" (click)="openCreateCompany()">
        <i class="fal fa-plus-circle"></i>
        <p class="m-0">Crear empresa</p>
      </div>
    </div>
  </div>

  <div *ngIf="loadingPage" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <div #containerScroll *ngIf="loaded" (scroll)="isScrolledInfinityView($event)">
    <div class="table-business table-panel multiple-lines bg-transparent">
      <!--Vista escritorio con tabla-->
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z28 d-none d-lg-table" matSort
      (matSortChange)="sortData($event)">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <!-- <i class="fal fa-ellipsis-vertical icon-option"></i> -->
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
        <td mat-cell *matCellDef="let item" class="pointer-in">
          <img fallimg class="image-table" [src]="getImageUrl(item.image_url)">
          <span class="link-titulo">{{item.name}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="cif">
        <th mat-header-cell *matHeaderCellDef><b>CIF</b></th>
        <td mat-cell *matCellDef="let item" class="pointer-in">
          <span>{{item.cif}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef><b>Dirección</b></th>
        <td mat-cell *matCellDef="let item">
          <div class="container-address pointer-in">
            <i class="fa-light fa-location-dot"></i>
            <span>{{item.address}}</span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="fee">
        <th mat-header-cell *matHeaderCellDef><b>Comisión taquilla</b></th>
        <td mat-cell *matCellDef="let item">
          <!-- El click no debe entrar en la empresa, que es lo que hace la fila -->
          <div class="container-fee pointer-in" (click)="editTicketOfficeFee(item); $event.stopPropagation()">
            <span>{{(item.ticket_office_fee || 0) | number:'1.2-4'}} €</span>
            <i class="fa-light fa-pen-to-square"></i>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef><b>Fecha creación</b></th>
        <td mat-cell *matCellDef="let item">
          <div class="pointer-in">
            <span>{{item.created_at | date: 'dd-MM-yyyy'}}</span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="open">
        <th mat-header-cell *matHeaderCellDef><b>Entrar</b></th>
        <td mat-cell *matCellDef="let item">
          <div class="pointer-in">
            <i class="fa-light fa-right-to-bracket"></i>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-active]="companySelect?.id==row.id"
        (click)="enterLikeCompany(row)"></tr>
    </table>
  </div>

  <!--Vista movil con cards-->
  <div class="movile-view d-block d-lg-none container">
    <div *ngFor="let item of dataSource.data" class="card-business pointer-in row p-0 rounded-3 mb-3"
      [class.card-active]="companySelect?.id==item.id" (click)="enterLikeCompany(item)">
      <div class="col-3 col-md-2 d-flex align-items-start p-1">
        <img fallimg class="image-card" [src]="getImageUrl(item.image_url)">
      </div>
      <div class="col-8 col-md-8 ps-4 ps-md-2">
        <span class="m-0 fs-6 d-block fw-semibold text-truncate">{{item.name}}</span>
        <span class="m-0 f-">{{item.cif}}</span>
        <div class="d-flex align-items-center mb-2">
          <i class="fa-light fa-location-dot me-2 text-primary"></i>
          <span class="text-truncate">{{item.address}}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="fa-light fa-calendar-check me-2 text-primary"></i>
          <span class="date">Creada el {{item.created_at | date: 'dd-MM-yyyy'}}</span>
        </div>
      </div>
      <div class="col-1 d-flex align-items-center justify-content-center pointer-in">
        <i class="fa-light fa-right-to-bracket text-primary fs-5 pe-2" [class.icon-active]="companySelect?.id==item.id"></i>
      </div>
    </div>
  </div>

  <div class="pagination-component">
    <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
      <div>
        <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
          containerClass="loading-box"></ng-lottie>
      </div>
    </div>
  </div>
</div>
<p *ngIf="loaded && !loadingPage && business?.length <= 0" style="text-align: center; margin-top: 80px;">No hay
  empresas disponibles</p>
</div>
